
import React, { useEffect, useState } from 'react';
import { ProSidebar } from 'react-pro-sidebar';
import "react-pro-sidebar/dist/css/styles.css";
import { useNavigate, useParams } from "react-router-dom";
import { OrgPreferences } from '../../model/UserModel';
import { RemoveOrganizationLocalStorage, RemoveWorkspaceLocalStorage } from '../../pages/PublicLayout/RedirectManager';
import { ContentbarProps, ISelectList } from '../Contentbar/ContentSide/ContentSideComp';
import ContentbarList from '../Contentbar/ContentSide/ContentSideList';
import { useContentBarRegular } from './useContentbar';
import { useContentBarAdmin } from './useContentBarAdmin';

export type isValidUserPendencies = 'true' | 'false' | 'waiting' | 'invisible';

interface IUseContentBarParameters {  isCollapsed: boolean, 
  nameOrg: string, 
  setIsCollapsed: (set: boolean) => void,
  navigateHome(): void,
  organization: string,
  setOrganization: (organization: string) => void,
  workspace: string,
  setWorkspace: (workspace: string) => void,

}

export interface IUseContentBarRegularParameters extends IUseContentBarParameters {
  fillColorSVG:() => "#2dc254" | "#dc3055" | "yellow" | "white";
  organizations: OrgPreferences[], 
  idWorkspace: string,

}

export interface IUseContentBarAdminParameters extends IUseContentBarParameters {}

interface SidebarProps {
  onChange?: (event: React.MouseEvent, isChecked?: boolean) => void;
  isCheckedInitial: boolean;
  isOrganizationVisible: boolean;
  idOrganization?: string;
  isWorkspaceVisible: boolean;
  isUsersVisible: boolean;
  isGroupspaceVisible: boolean;
  isDocuemntTypeVisible: boolean;
  isValidationRuleVisible: boolean;
  isFileVisible: boolean;
  idFeedTrackerVisible: boolean;
  idSharedItemVisible:boolean;
  isUserPendencies?: isValidUserPendencies;
  internalName?: string;
  isHambNavbar?: boolean;
  catchContentbar: (contentForBar: ContentbarProps<ISelectList>[]) => void
  hasBeenUpdated: boolean,
  idSelectd: number | undefined;
  setIdSelectd: (newIndex: number | undefined) => void;
  organizations: OrgPreferences[];
  isAdminConsolePage: boolean;
  setIsCollapsed: (set: boolean) => void;
  isCollapsed: boolean;
}

export function Sidebar({
  onChange,
  idOrganization,
  internalName,
  isCheckedInitial,
  isOrganizationVisible,
  isWorkspaceVisible,
  isUsersVisible,
  isGroupspaceVisible,
  isDocuemntTypeVisible,
  isValidationRuleVisible,
  isFileVisible,
  isUserPendencies,
  idFeedTrackerVisible,
  idSharedItemVisible,
  isHambNavbar,
  catchContentbar,
  hasBeenUpdated,
  idSelectd,
  setIdSelectd,
  organizations,
  setIsCollapsed,
  isAdminConsolePage,
  isCollapsed,
  ...rest
}: SidebarProps) {
  const { nameOrg, idWorkspace } = useParams();
  const [organization, setOrganization] = useState<string>("");
  const [workspace, setWorkspace] = useState<string>("");

  const navigate = useNavigate();

  const {
    contentBar,
  } = useContentBarRegular({
    idWorkspace: idWorkspace!,
    isCollapsed,
    nameOrg: nameOrg!,
    organizations,
    setIsCollapsed,
    fillColorSVG,
    navigateHome,
    organization,
    setOrganization,
    setWorkspace,
    workspace,
  });

  const {
    contentBarAdmin,
  } = useContentBarAdmin({
    isCollapsed,
    nameOrg: nameOrg!,
    setIsCollapsed,
    organization,
    navigateHome,
    setOrganization,
    setWorkspace,
    workspace,
  });

  useEffect(() => {
    let persistedCollapsedSidebar = localStorage.getItem("persistedCollapsedSidebar");
    if (persistedCollapsedSidebar !== undefined && persistedCollapsedSidebar !== null) {
      setIsCollapsed(persistedCollapsedSidebar == "true" ? true : false);
    }
  }, []);

  function fillColorSVG() {
    if (isUserPendencies == "false") {
      return "#2dc254"
    } else if (isUserPendencies == "true") {
      return "#dc3055"
    } else if (isUserPendencies == "waiting") {
      return "yellow"
    }

    return "white"
  }

  function navigateHome() {
    navigate("/");
    setOrganization("");
    setWorkspace("");

    RemoveWorkspaceLocalStorage();
    RemoveOrganizationLocalStorage();
  }

  return (
    <ProSidebar
      width="220px"
      collapsedWidth="66px"
      collapsed={isCollapsed}
      color='#000'
      className={isAdminConsolePage ? 'admin' : 'regular'}
    >
      <ContentbarList
        contentList={isAdminConsolePage ? contentBarAdmin : contentBar}
        isCollapsed={isCollapsed}
        nameOrg={nameOrg!}
        isAdminConsolePage={isAdminConsolePage}
      />
    </ProSidebar>
  );
}

export default Sidebar;